//Built in Libraries
import React, { Fragment, ReactNode } from "react";

//Third Part Libraries
import { Transition, Menu } from "@headlessui/react";

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(" ");
}
const directions = {'left': 'left-0', 'right': 'right-0'}

export type direction = 'left' | 'right'

interface SimpleDropDownProps {
  toggle: ReactNode;
  children: ReactNode;
  className?: string;
  itemContainerWidth?: string;
  menuButtonClassName?: string;
  menuItemClassName?: string;
  bigItem?: boolean;
  direction?: direction;
}

interface DropDownItemProps {
  onClick?: () => void;
  children: ReactNode;
  id: string;
  dropDownTitle?: boolean;
}
export const DropDownItem = ({
  onClick,
  children,
  id,
  dropDownTitle,
}: DropDownItemProps) => (
  <Menu.Item>
    {({ active }) => (
      <div
        id={id}
        className={classNames(
          active && !dropDownTitle
            ? "bg-green-50 border-l-4 border-green-500 border-opacity-100"
            : "",
          "block flex gap-2 px-2 py-2 text-sm text-gray-500 cursor-pointer border-l-4 border-opacity-0"
        )}
        onClick={onClick}
      >
        {children}
      </div>
    )}
  </Menu.Item>
);
const SimpleDropDown = ({
  toggle,
  children,
  className = "",
  itemContainerWidth,
  bigItem,
  menuButtonClassName = "",
  menuItemClassName = "",
  direction = "right"
}: SimpleDropDownProps) => {
  return (
    <Fragment>
      <Menu
        as="div"
        className={`${bigItem || "relative"} flex-shrink-0 top-0 ${className}`}
      >
        <Menu.Button
          className={`${
            menuButtonClassName || "w-full rounded-full flex text-sm mt-0"
          }`}
        >
          <span className="sr-only">Open user menu</span>
          {toggle}
        </Menu.Button>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items
            className={`origin-top-right absolute z-20 ${directions[direction]} mt-2 ${
              itemContainerWidth || "w-48"
            } rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none ${menuItemClassName}`}
          >
            {children}
          </Menu.Items>
        </Transition>
      </Menu>
    </Fragment>
  );
};

export default SimpleDropDown;
